import { Modal, Button } from "@mui/material";
import styled from "styled-components";
import BasicTitle from "../title";

const ModalCenter = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 436px;
    max-width: 632px;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 8px;
    border: 1px solid rgb(144, 144, 144);
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);

    @media (max-width: 800px) {
        margin-right: 16px;
        width: calc(100% - 32px);
    }
`;

const ModalClose = styled.img`
    position: absolute;
    right: 40px;
    top: 40px;
    cursor: pointer;
    z-index: 10;
    width: 24px;
    height: 24px;
`;

const ModalContent = styled.div`
    display: flex;
    padding: 40px;
`;

const Content = styled.div`
    flex: 1;
`;

const SecondaryButton = styled(Button)`
    && {
        background: transparent;
        color: #000;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        text-transform: none;
        padding: 12px 24px;
        border-radius: 8px;
        text-transform: uppercase;
        border: 1px solid #000;

        &:disabled {
            background: #e4e4e4;
            color: #999;
        }
    }
`;

const PrimaryButton = styled(Button)`
    && {
        background: #57c4c2;
        color: #000;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        text-transform: none;
        padding: 12px 24px;
        border-radius: 8px;
        text-transform: uppercase;

        &:hover {
            background: #4ba09b;
        }

        &:disabled {
            background: #e4e4e4;
            color: #999;
        }
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const ModalExitWithoutSaving = ({ open, onClose, onConfirmExit, onGoBack }) => {

    return (
        <Modal
            open={open}
            onClose={onClose}
        >
            <ModalCenter style={{ overflowY: "auto", maxHeight: "95%", padding: 0, border: 0 }}>
                <ModalClose
                    src="/img/modal_close.svg"
                    onClick={onClose}
                />
                <ModalContent>
                    <Content>
                        <BasicTitle showLine title='Resetar senha' margin={24}/>
                        <ButtonContainer>
                            <SecondaryButton onClick={onConfirmExit}>
                                sim, sair sem copiar senha
                            </SecondaryButton>
                            <PrimaryButton onClick={onGoBack}>
                                Copiar senha
                            </PrimaryButton>
                        </ButtonContainer>
                    </Content>
                </ModalContent>
            </ModalCenter>
        </Modal>
    );
}

export default ModalExitWithoutSaving;

